'use client'
import type { StockStatusSkeletonProps } from '@pearlconvert/ui/components/stock-status/stock-status.types'

import classNames from 'classnames'
import React from 'react'

export const StockStatusSkeleton: React.FC<StockStatusSkeletonProps> = (
  props: StockStatusSkeletonProps
) => {
  const { position = 'left', variant = 'one-line' } = props
  return (
    <div
      className={classNames('stock-status stock-status--skeleton', {
        [`stock-status--${position}`]: position,
        [`stock-status--${variant}`]: variant,
      })}
    >
      <span className="stock-status__info">
        <span className="stock-status__label"></span>
        {variant === 'two-lines' && (
          <span className="stock-status__aside"></span>
        )}
      </span>
    </div>
  )
}
